module.exports = __webpack_public_path__ + "public/img/立即购买.fca6ccf8.png";